/**
 * Specifies the location of the fallback provision documentation.
 * tag: 41088
 * @readonly
 * @enum {number} (int)
 */
export enum MarketDisruptionFallbackProvision {
  /** As specified in master agreement */
  MasterAgreement = 0,
  /** As specified in confirmation */
  Confirmation = 1,
}
